export const isUtenteSpeciale = (utente) =>
  Boolean(utente?.permessiAPI?.["update:dbrevisioni"]) &&
  !utente?.permessiAPI?.["update:database"];

export const ARTICOLO_ASSENTE_SOLA_LETTURA =
  "Articolo non presente: utente in sola lettura";
